// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"51b1feee","239":"87b61906","553":"0c00de6b"}[chunkId] + ".chunk.js";
};